import { InterventionStatus } from '@features/siteStatusV2/constants/report';

const MapInterventionStatusToDisplay: Record<InterventionStatus, string> = {
  [InterventionStatus.CANCELED]: 'report.interventionStatus.canceled',
  [InterventionStatus.CREATED]: 'report.interventionStatus.created',
  [InterventionStatus.STARTED]: 'report.interventionStatus.started',
  [InterventionStatus.IN_PROGRESS]: 'report.interventionStatus.inProgress',
  [InterventionStatus.PLANNED]: 'report.interventionStatus.planned',
  [InterventionStatus.QUALIFIED]: 'report.interventionStatus.qualified',
  [InterventionStatus.COMPLETED]: 'report.interventionStatus.completed',
  [InterventionStatus.SUSPENDED]: 'report.interventionStatus.suspended',
  [InterventionStatus.SYNCHRONIZED]: 'report.interventionStatus.synchronized',
  [InterventionStatus.FINISHED]: 'report.interventionStatus.finished',
  [InterventionStatus.WORK_REQUEST]: 'report.interventionStatus.workRequest',
  [InterventionStatus.RELEASED]: '-',
  [InterventionStatus.WORK_STARTED]: 'report.interventionStatus.workStarted',
  [InterventionStatus.WORK_DONE]: 'report.interventionStatus.workDone',
  [InterventionStatus.VALIDATED]: 'report.interventionStatus.validated',
  [InterventionStatus.NO_STATUS]: '-'
};

export default MapInterventionStatusToDisplay;
